<template>
    <div class="content-item-file" @click="openFile(file_url)">
        <div class="file-type" :style="{background:getFileType(file_url)=='W'?'#3691dd' : (getFileType(file_url)=='X'?'#1eba7d':(getFileType(file_url)=='P'?'#f36d44':(getFileType(file_url)=='rar'?'#a97c4a':'#ff686a')))}">{{getFileType(file_url)}}</div>
        <div class="file-name">{{file_name}}</div>
    </div>
</template>
<script>
export default {
   name: 'OpenDocument',
   props: {
       file_name: {
           type: String,
           default: ''
       },
       file_url: {
           type: String,
           default: ''
       }
   },
   methods: {
       getFileType(file_url) {
          let str = file_url.substring(file_url.length - 6)
          let type = ''
          if (str.indexOf('docx') != -1 || str.indexOf('DOCX') != -1 || str.indexOf('doc') != -1 || str.indexOf('DOC') != -1) type = 'W'
          if (str.indexOf('xlsx') != -1 || str.indexOf('XLSX') != -1 || str.indexOf('xls') != -1 || str.indexOf('XLS') != -1) type = 'X'
          if (str.indexOf('pptx') != -1 || str.indexOf('PPTX') != -1 || str.indexOf('ppt') != -1 || str.indexOf('PPT') != -1) type = 'P'
          if (str.indexOf('pdf') != -1 || str.indexOf('PDF') != -1) type = 'pdf'
          if (str.indexOf('rar') != -1 || str.indexOf('RAR') != -1) type = 'rar'
        return type
      },
      openFile(url) {
        window.open(url)
      },
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}

.content-item-file {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: rem(120);
    background-color: #f2f2f7;
    padding: rem(20);
    border-radius: rem(8);
    overflow: hidden;
    box-sizing: border-box;
}
.file-type {
    width: rem(80);
    height: rem(80);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: rem(32);
    border-radius: rem(8);
    margin-right: rem(16);
}
.file-name {
    flex: 1;
    font-size: rem(26);
    color: #262626;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/OpenDocument.vue